module.exports = "//static.hsappstatic.net/InboxConnectUtils/static-4.8542/images/unknown-email.svg"